export default "__VITE_ASSET__PCj$u33O__"